<nav class="bg-[#343a40]">
    <div class="mx-auto px-4 lg:px-8 drop-shadow-lg">
        <div class="flex items-center justify-between h-20">
            <img
                src="../../../../assets/zevotech-logo.png"
                alt="Logo"
                class="h-12"
            />
            <span class="flex gap-4">
                <a
                    class="nav-btn"
                    [routerLink]="['']"
                    [routerLinkActive]="'--active'"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [ariaCurrentWhenActive]="'page'"
                    (click)="onHomeListener()"
                    >Home</a
                >
                <a
                    *ngIf="isLoggedIn()"
                    class="nav-btn"
                    [routerLink]="['/history']"
                    [routerLinkActive]="'--active'"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [ariaCurrentWhenActive]="'page'"
                    >History</a
                >
                <a
                    *ngIf="isLoggedIn()"
                    class="nav-btn"
                    [routerLink]="['/profile']"
                    [routerLinkActive]="'--active'"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [ariaCurrentWhenActive]="'page'"
                    >Profile</a
                >
                <zt-button
                    *ngIf="!isLoggedIn(); else loggedOutBtn"
                    [config]="loginBtnConfig"
                    [type]="ZtButtonType.PRIMARY"
                    [rounded]="true"
                    (onClick)="onLoginListener()"
                ></zt-button>
                <ng-template #loggedOutBtn>
                    <zt-button
                        [config]="logoutBtnConfig"
                        [type]="ZtButtonType.PRIMARY"
                        [rounded]="true"
                        (onClick)="onLogoutListener()"
                    ></zt-button>
                </ng-template>
            </span>
        </div>
    </div>
</nav>
